import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";
import { trackServerEvent } from "../utils/serverAnalytics";

/**
 * Hook that tracks page views on every route change.
 * Sends to both Google Analytics and server-side analytics.
 */
export const usePageTracking = (): void => {
    const location = useLocation();
    const prevPath = useRef(location.pathname);

    useEffect(() => {
        const fullPath = location.pathname + location.search;
        trackPageView(fullPath);
        trackServerEvent("page_view", { page_path: fullPath });
        prevPath.current = location.pathname;
    }, [location]);
};
